import fpgConfiguration from '@/store/fpgConfiguration';
import configuration from '@/store/configuration';
import {
  isExemptedPath,
  redirectToIamBff,
  buildProxyUrl,
} from '@/services/interceptors/InterceptorUtils';
import authState from '@/store/auth';

export function gatewayInterceptor(config) {
  let isTileMode = fpgConfiguration.state.isTileMode;
  let isIamBff = configuration.state.isIamBff;
  if (isTileMode) {
    if (config.baseURL.includes('localhost')) {
      config.baseURL = '/fleet-account' + config.baseURL;
    } else {
      let host = window.location.hostname;
      let decodedConfigUrl = decodeURIComponent(config.url);
      try {
        const urlObj = new URL(config.url);
        decodedConfigUrl =
          urlObj.pathname.replace(new RegExp('^/[^/]+'), '') + urlObj.search;
      } catch {}
      let encodedUrl = encodeURIComponent(configuration.state.apigeeApiBaseUrl);
      config.baseURL = buildProxyUrl(host, encodedUrl);
      config.url = encodeURIComponent(decodedConfigUrl);
    }
  } else if (isIamBff) {
    if (authState.state.isLoggedIn) {
      redirectToIamBff(config, configuration.state.apigeeApiBaseUrl);
    } else if (
      !isExemptedPath(
        config.url,
        configuration.state.iamBffAccountExemptedUrls,
        '/account-api'
      )
    ) {
      redirectToIamBff(config, configuration.state.apigeeApiBaseUrl);
    }
  }
  return config;
}
